import { render, staticRenderFns } from "./PreviewCode.vue?vue&type=template&id=b3a8537e&scoped=true"
import script from "./PreviewCode.vue?vue&type=script&lang=js"
export * from "./PreviewCode.vue?vue&type=script&lang=js"
import style0 from "./PreviewCode.vue?vue&type=style&index=0&id=b3a8537e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a8537e",
  null
  
)

export default component.exports